/**
 * Une option « structurée » porte un sous-titre, un contenu à droite ou un libellé
 * d'affichage distinct. Les autres (pays, compagnies, clients…) gardent le rendu et
 * les états d'origine : cette distinction est ce qui rend l'évolution non régressive.
 */
export const isStructuredOption = (option) => option.iconTone === 'brand' || option.description !== undefined || option.rowLabel !== undefined;
